import { Field, useFormikContext } from "formik";
import React from "react";
import DeleteIcon from "../../../../../assets/icons/delete-icon";

function TableContent({ tableHeading, values, onClickDelete }) {
  const { setFieldValue } = useFormikContext();
  const handleFieldChange = (index, field, value, setFieldValue) => {
    setFieldValue(`${index}.${field}`, value);
  };
  return (
    <div className="overflow-auto mb-auto rounded-xl table-container border border-gray-200">
      <table className=" w-full ">
        <thead className="sticky top-0 bg-[var(--create-table-header-bg)] z-[10]">
          <tr className="relative h-[50px]">
            {tableHeading.map((heading, index) => (
              <th
                className={`text-start px-[8px] whitespace-nowrap text-[var(--create-table-header-fg)] text-[length:var(--create-table-header-fs)] font-[var(--create-table-header-fw)]`}
                key={heading}
              >
                {heading?.toUpperCase()}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {values?.data?.map((item, index) => (
            <tr
              className={` bg-[var(--list-table-row-bg)]
                          h-[50px] `}
              key={index}
            >
              <td className="tab-cell text-sm fw_400 text-secondary w-2/12">
                <Field
                  maxLength={20}
                  onChange={(e) => {
                    handleFieldChange(
                      `data[${index}]`,
                      "code",
                      e.target.value,
                      setFieldValue
                    );
                  }}
                  name={`data[${index}].code`}
                  placeholder="Enter Code"
                  className="border-0 focus:outline-none focus:ring focus:ring-blue-500 rounded px-1 py-2"
                />
              </td>
              <td className="tab-cell text-sm fw_400 text-secondary w-2/12">
                <Field
                  maxLength={20}
                  onChange={(e) => {
                    let value = e.target.value;
                    value = value.replace(/^\s+/, "");
                    value = value.replace(/\s+/g, " ");
                    handleFieldChange(
                      `data[${index}]`,
                      "name",
                      value,
                      setFieldValue
                    );
                  }}
                  name={`data[${index}].name`}
                  placeholder="Enter Name"
                  className="border-0 focus:outline-none focus:ring focus:ring-blue-500 rounded py-2"
                />
              </td>
              <td className="tab-cell text-sm fw_400 text-secondary w-7/12">
                <Field
                  maxLength={80}
                  onChange={(e) => {
                    let value = e.target.value;
                    value = value.replace(/^\s+/, "");
                    value = value.replace(/\s+/g, " ");
                    handleFieldChange(
                      `data[${index}]`,
                      "discription",
                      value,
                      setFieldValue
                    );
                  }}
                  name={`data[${index}].discription`}
                  placeholder="Enter Description"
                  className="w-full border-0 focus:outline-none focus:ring focus:ring-blue-500 rounded py-2"
                />
              </td>
              <td className="tab-cell align-middle text-sm fw_400 text-secondary w-1/12 ">
                <div className="flex items-center">
                  <button type="button" onClick={() => onClickDelete(item?.id)}>
                    <DeleteIcon />
                  </button>
                </div>
              </td>
            </tr>
          ))}
          <tr>
            <td className="tab-cell text-sm fw_400 text-secondary w-2/12">
              <Field
                maxLength={20}
                onChange={(e) => {
                  handleFieldChange(`newLine`, "code", e.target.value, setFieldValue);
                }}
                name="newLine.code"
                placeholder="Enter Code"
                className="border-0 focus:outline-none focus:ring focus:ring-blue-500 rounded px-1 py-2"
              />
            </td>
            <td className="tab-cell text-sm fw_400 text-secondary w-2/12">
              <Field
                maxLength={20}
                onChange={(e) => {
                  let value = e.target.value;
                  value = value.replace(/^\s+/, "");
                  value = value.replace(/\s+/g, " ");
                  handleFieldChange(`newLine`, "name", value, setFieldValue);
                }}
                name="newLine.name"
                placeholder="Enter Name"
                className="border-0 focus:outline-none focus:ring focus:ring-blue-500 rounded px-1 py-2"
              />
            </td>
            <td className="tab-cell text-sm fw_400 text-secondary w-7/12">
              <Field
                maxLength={80}
                onChange={(e) => {
                  let value = e.target.value;
                  value = value.replace(/^\s+/, "");
                  value = value.replace(/\s+/g, " ");
                  handleFieldChange(
                    `newLine`,
                    "discription",
                    value,
                    setFieldValue
                  );
                }}
                name="newLine.discription"
                placeholder="Enter Description"
                className="w-full border-0 focus:outline-none focus:ring focus:ring-blue-500 rounded px-1 py-2"
              />
            </td>
            <td className="tab-cell text-sm fw_400 text-secondary w-1/12"></td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}

export default TableContent;
